import api from "./api";

// The customer app's roles, for picking an invitee's role. 'User' still exists
// in every company but behaves like Manager, so it isn't offered (as in the
// customer apps).
const HIDDEN_ROLES = ["User"];

// What each role can do in the customer apps; keep in step with the customer
// apps' role.service ROLE_INFO.
export const CUSTOMER_ROLE_INFO = {
  Administrator:
    "Sees every location. Can request service, respond to recommendations, and manage the team, notifications and locations.",
  Manager: "Sees only the locations they're assigned to. Can request service and respond to recommendations there.",
};

const getNames = () =>
  api.get("/api/customer-role/names").then((response) => ({
    ...response,
    data: (response.data ?? []).filter((role) => !HIDDEN_ROLES.includes(role.name)),
  }));

const CustomerRoleService = { getNames };

export default CustomerRoleService;
